"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./vertical-scroll-box.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
  On render, will recalculate scroll indicators if the children length changes or if the
  optional updateKey property is not equal to the previous value.
 */
var VerticalScrollBox = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(VerticalScrollBox, _React$PureComponent);

  var _super = _createSuper(VerticalScrollBox);

  function VerticalScrollBox(props) {
    var _this;

    _classCallCheck(this, VerticalScrollBox);

    _this = _super.call(this, props);
    _this.state = {};
    _this.updateScrollIndicators = _this.updateScrollIndicators.bind(_assertThisInitialized(_this));
    _this.scrollDidMount = _this.scrollDidMount.bind(_assertThisInitialized(_this));
    _this.scrollBy = _this.scrollBy.bind(_assertThisInitialized(_this));
    _this.scrollTo = _this.scrollTo.bind(_assertThisInitialized(_this));
    _this.outerElementDidMount = _this.outerElementDidMount.bind(_assertThisInitialized(_this));
    _this.scrollContentDidMount = _this.scrollContentDidMount.bind(_assertThisInitialized(_this));
    _this.sizeContent = _this.sizeContent.bind(_assertThisInitialized(_this));
    _this.sizeContentOnBodyAnimationEnd = _this.sizeContentOnBodyAnimationEnd.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(VerticalScrollBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var _this$props = this.props,
          children = _this$props.children,
          updateKey = _this$props.updateKey;

      if (oldProps.children.length !== children.length || oldProps.updateKey !== updateKey) {
        this.sizeContent();
      } else {
        this.updateScrollIndicators();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.sizeContent);
      document.body.removeEventListener('animationend', this.sizeContentOnBodyAnimationEnd);
      document.body.removeEventListener('transitionend', this.sizeContentOnBodyAnimationEnd);
    }
  }, {
    key: "updateScrollIndicators",
    value: function updateScrollIndicators() {
      this.setState({
        contentUp: this.element.scrollTop > 0,
        contentDown: this.element.scrollTop < this.element.scrollHeight - this.element.offsetHeight
      });
    }
  }, {
    key: "scrollDidMount",
    value: function scrollDidMount(scroll) {
      var onScroll = this.props.onScroll;

      if (scroll) {
        this.element = scroll;
        scroll.addEventListener('scroll', this.updateScrollIndicators);

        if (onScroll) {
          scroll.addEventListener('scroll', onScroll);
        }

        this.updateScrollIndicators();
        window.addEventListener('resize', this.sizeContent);
      }
    }
  }, {
    key: "scrollBy",
    value: function scrollBy(offsetX, offsetY) {
      this.scrollTo(this.element.scrollTop + offsetY, this.element.scrollLeft + offsetX);
    }
  }, {
    key: "scrollTo",
    value: function scrollTo(x, y) {
      this.element.scrollTop = x;
      this.element.scrollLeft = y;
      this.updateScrollIndicators();
    }
  }, {
    key: "sizeContentOnBodyAnimationEnd",
    value: function sizeContentOnBodyAnimationEnd(e) {
      if (e.target && e.target.contains && e.target.contains(this.outerElement)) {
        this.sizeContent();
      }
    }
  }, {
    key: "outerElementDidMount",
    value: function outerElementDidMount(element) {
      this.outerElement = element;
      this.sizeContent();
      document.body.addEventListener('animationend', this.sizeContentOnBodyAnimationEnd);
      document.body.addEventListener('transitionend', this.sizeContentOnBodyAnimationEnd);
    }
  }, {
    key: "scrollContentDidMount",
    value: function scrollContentDidMount(element) {
      this.contentElement = element;
      this.sizeContent();
    }
  }, {
    key: "sizeContent",
    value: function sizeContent() {
      if (!this.outerElement || !this.contentElement) {
        return;
      }

      this.contentElement.style.width = "".concat(this.outerElement.offsetWidth, "px");
      this.outerElement.style.height = ''; // allow it to resize based on the css

      this.outerElement.style.height = "".concat(this.outerElement.offsetHeight, "px");
      this.updateScrollIndicators();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className;
      var _this$state = this.state,
          contentUp = _this$state.contentUp,
          contentDown = _this$state.contentDown;
      var classes = (0, _classnames["default"])('ScrollBox', className, {
        contentUp: contentUp,
        contentDown: contentDown
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.outerElementDidMount,
        className: classes
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.scrollDidMount,
        className: "verticalScrollBox"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.scrollContentDidMount,
        className: "scroll-box-content"
      }, children)));
    }
  }]);

  return VerticalScrollBox;
}(_react["default"].PureComponent);

exports["default"] = VerticalScrollBox;
VerticalScrollBox.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  onScroll: _propTypes["default"].func,
  updateKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].bool, _propTypes["default"].node])
};
VerticalScrollBox.defaultProps = {
  className: null,
  onScroll: null,
  updateKey: null
};